import React from "react";
import moment from "moment/moment";
import classes from "./NotificationList.module.css";

const NotificationList = ({ notification }) => {
  const message = JSON.parse(notification?.message);
  
  // Format the date as a relative time (e.g., "today", "1 day ago", "1 week ago")
  const formatRelativeTime = (dateString) => {
    if (!dateString) return "";
    
    const date = moment(dateString);
    
    // Check if the date is valid
    if (!date.isValid()) return "";
    
    // Return relative time
    return date.fromNow();
  };

  return (
    <div className={classes.notificationList}>
      <span className={classes.notificationTitle}>{notification?.createdBy}</span>
      <div className={classes.notificationListContainer}>
        <p>{message.Title}</p>
        <time className={classes.time}>
          {formatRelativeTime(notification?.createdDate)}
        </time>
      </div>
    </div>
  );
};

export default NotificationList;
